import {Action} from '@ngrx/store';
import {SessionModel} from './session.model';

export const enum sessionActionsType {
	DEMANDE_SESSION = '[Session] demande session',
	DEMANDE_SESSION_OK = '[Session] demande session ok',
	DEMANDE_SESSION_KO = '[Session] demande session ko'
}


// 1 Implémentation actions login
export class DemandeSession implements Action {
	readonly type = sessionActionsType.DEMANDE_SESSION;

	constructor(public payload: number) {
	}
}
export class DemandeSessionOk implements Action {
	readonly type = sessionActionsType.DEMANDE_SESSION_OK;

	constructor(public payload: SessionModel) {
	}
}
export class DemandeSessionKo implements Action {
	readonly type = sessionActionsType.DEMANDE_SESSION_KO;

	constructor(public payload: string) {
	}
}



export type actions =
	DemandeSession
	| DemandeSessionOk
	| DemandeSessionKo;
